import { type FunctionComponent, Suspense } from 'react';
import { SelectCategoriesField, type SelectCategoriesFieldProps } from './SelectCategoriesField';
import { SelectCategoriesFieldStub } from './SelectCategoriesFieldStub';

export const SelectCategoriesFieldSuspended: FunctionComponent<SelectCategoriesFieldProps> = ({
    'data-testid': dataTestId = 'CategoriesField',
    ...props
}) => (
    <Suspense fallback={<SelectCategoriesFieldStub />}>
        <SelectCategoriesField data-testid={dataTestId} {...props} />
    </Suspense>
);
